// extracted by mini-css-extract-plugin
export default {"numberSubheading":"NestedList__numberSubheading___insRR"};